import Swiper from "swiper"
import { Autoplay, Navigation, Pagination } from "swiper/modules"
import { Marquee } from "./lib/marquee"
import { Tabs } from "./components/tabs/tabs.js"
import { Accordion } from "./components/accordions/accordion.js"
import { ValidateForm } from "./services/validateForm.js"
import { ShowProposalForm } from "./services/showProposalForm.js"
import { DialTabsInit } from "./services/TabsInit.js"
import { ContactForm } from "./services/showContactForm.js"
import { articleCardsInit } from "./services/showArticleCards.js"
import { playVideoInit } from "./services/playVideo.js"
import { articleSearchInit } from "./services/openArticleSearch.js"
import { HeaderSearchInit } from "./services/openHeaderSearch.js"
import { showBurger } from "./services/burgerInit.js"
import { headerDropDownInit } from "./services/initHeaderDropDown.js"
import { langSwitchInit } from "./services/langSwitch.js"
import { FeatureItems } from "./services/showFeaturesItem.js"
import { playAudioInit } from "./services/audioPlay.js"
import { initSwiperResize } from "./services/swiperResize.js"
import { currencyListInit } from "./services/openCurrencyList.js"
import { initPaymnetToggle } from "./services/togglePaymentPlan.js"
import { HighlightText } from "./services/highlightText.js"
import { ToggleItemsInit } from "./services/toggleItemsInit.js"
import { CurrencyDropdown } from "./services/CurrencySwitcher.js"
import { wrapTable } from "./services/tableWrap"
import initUniversalPlayer from "./modules/universal-player"

/**
 * Show hidden elements as modals, popups, tooltips, etc.
 * In a first load webpage html elements loads before styles. That's all
 * elements with transition is jumping on a page.
 * @type { NodeListOf<HTMLElement> }
 * */
const hiddenElements = document.querySelectorAll(".important_none")

window.addEventListener("load", async () => {
  hiddenElements.forEach(($el) => $el.classList.remove("important_none"))
  //   const linksToCheckTelPattern = document.querySelectorAll("a")
  //   linksToCheckTelPattern &&
  //     linksToCheckTelPattern.forEach((linkTel) => convertLinkToTelPattern(linkTel))
})

setupManualTabProgress()
openCallModal()
articleVoted()
zoomArticleImage()
openIntegrationFilters()
setupFilterReset()

new showBurger()
new ValidateForm()
new ShowProposalForm()
new articleCardsInit()
new playVideoInit()
new articleSearchInit()
new headerDropDownInit()
new langSwitchInit()
new playAudioInit()
new initSwiperResize()
new currencyListInit()
new initPaymnetToggle()
new HighlightText()
new HeaderSearchInit()

new CurrencyDropdown()

new DialTabsInit("dialTabs", "flex")
new DialTabsInit("stepsTab", "block")
new DialTabsInit("featuresTabs", "flex")
new DialTabsInit("contactCenterTabs", "flex")
new DialTabsInit("productTab", "block", ".nav_icon.prev", ".nav_icon.next")
new DialTabsInit("functionsTab", "block", ".nav_icon.prev", ".nav_icon.next")

new ToggleItemsInit({
  wrapSelector: ".dial_choise_card-wrap",
  cardSelector: ".dial_choise_card",
  listSelector: ".card_list ul",
  showBtnSelector: ".toggle_list_button",
  hideThreshold: 4,
})

// new ToggleItemsInit({
//   wrapSelector: ".plan_body",
//   cardSelector: ".plan_card",
//   listSelector: ".card_list",
//   showBtnSelector: ".toggle_list_button",
//   hideThreshold: 5,
// })

new FeatureItems(".tabs__item", {
  initiallyVisibleCount: 6,
})

window.addEventListener("resize", function () {
  if (window.innerWidth <= 992) {
    new FeatureItems(".control", {
      buttonSelector: ".control_btn",
      cardWrapSelector: ".control_content",
      cardSelector: ".control_row",
      initiallyVisibleCount: 3,
      fadeDuration: 300,
      fadeDisplay: "flex",
    })
  }
})

// Initialize important items show more on mobile

new FeatureItems(".important", {
  buttonSelector: ".important__btn-more",
  cardWrapSelector: ".important__list",
  cardSelector: ".important__item",
  initiallyVisibleCount: 5,
  fadeDuration: 300,
  fadeDisplay: "flex",
})

{
  window.innerWidth <= 992 &&
    new FeatureItems(".important", {
      buttonSelector: ".important__btn-more",
      cardWrapSelector: ".important__list",
      cardSelector: ".important__item",
      initiallyVisibleCount: 4,
      fadeDuration: 300,
      fadeDisplay: "flex",
    })
}

new FeatureItems(".familiar_autoinformer-functions", {
  buttonSelector: ".familiar_autoinformer-button",
  cardWrapSelector: ".familiar_autoinformer-wrap",
  cardSelector: ".familiar_card",
  initiallyVisibleCount: 6,
  fadeDuration: 300,
  fadeDisplay: "block",
})

new FeatureItems(".popular-integration", {
  buttonSelector: ".popular-integration__btn-more",
  cardWrapSelector: ".popular-integration__item-list",
  cardSelector: ".popular-integration__item",
  initiallyVisibleCount: 9,
  fadeDuration: 300,
  fadeDisplay: "flex",
})

new FeatureItems(".familiar_crm", {
  buttonSelector: ".familiar_button",
  cardWrapSelector: ".familiar_crm-wrap",
  cardSelector: ".familiar_card",
  initiallyVisibleCount: 6,
  fadeDuration: 300,
  fadeDisplay: "block",
})

new ContactForm(".question_link", "#form-modal", "#contact-form-modal")
new ContactForm(".custom_link", "#form-modal2", "#contact-form-modal2")
new ContactForm(".btn_request", "#form-modal3", "#contact-form-modal3")
new ContactForm("a[href='#btn_request']", "#form-modal3", "#contact-form-modal3")

document.querySelectorAll(".btn_request").forEach((btn) => {
  btn.addEventListener("click", () => {
    if (document.querySelector('#contact-form-modal3 input[name="type"]')) {
      document.querySelector('#contact-form-modal3 input[name="type"]').value =
        btn.getAttribute("data-text_input") || "order"
    }
  })
})

document.querySelectorAll(".custom_link").forEach((btn) => {
  btn.addEventListener("click", () => {
    if (document.querySelector('#contact-form-modal2 input[name="type"]')) {
      document.querySelector('#contact-form-modal2 input[name="type"]').value =
        btn.getAttribute("data-text_input") || "order"
    }
  })
})

new Swiper(".call_swiper", {
  modules: [Pagination],
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 2500,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1201: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
  },
})

new Swiper(".result_swiper", {
  modules: [Navigation, Pagination],
  slidesPerView: 3,
  spaceBetween: 20,
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 2500,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".result_swiper .result-swiper-button-next",
    prevEl: ".result_swiper .result-swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.06,
      spaceBetween: 20,
    },
    540: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
})

new Swiper(".reviews_swiper", {
  modules: [Navigation, Pagination],
  slidesPerView: 3,
  spaceBetween: 20,
  speed: 1000,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".reviews_head .swiper-button-next",
    prevEl: ".reviews_head .swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.06,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
})

new Swiper(".applications_icon_swiper", {
  modules: [Navigation],
  slidesPerView: 7,
  spaceBetween: 30,
  speed: 1000,
  navigation: {
    nextEl: ".applications_navigation .swiper-button-next",
    prevEl: ".applications_navigation .swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 'auto',
      spaceBetween: 8,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 14,
    },
    1480: {
      slidesPerView: 5,
      spaceBetween: 18,
    },
    1481: {
      slidesPerView: 6,
      spaceBetween: 45,
    },
  },
})

new Swiper(".write-about-us_swiper", {
  modules: [Navigation, Pagination],
  slidesPerView: 2,
  spaceBetween: 20,
  speed: 1000,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".write-about-us_head .swiper-button-next",
    prevEl: ".write-about-us_head .swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.05,
      spaceBetween: 10,
    },
    565: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
})

new Swiper(".reviews_second_swiper", {
  modules: [Navigation, Pagination],
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".review_second-swiper-button-next",
    prevEl: ".review_seconds-swiper-button-prev",
  },
  speed: 1000,
  autoplay: {
    delay: 2500,
  },
  loop: true,
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 1,
      spaceBetween: 40,
    },
  },
})

new Swiper(".article_swiper", {
  modules: [Navigation],
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1.06,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
  },
})

initSwiperProduct()
let swiperProduct

function initSwiperProduct() {
  if (window.innerWidth < 769) {
    if (!swiperProduct) {
      swiperProduct = new Swiper(".product_swiper", {
        modules: [Navigation],
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          320: {
            slidesPerView: 1.06,
            spaceBetween: 20,
            centeredSlides: true,
          },
          576: {
            slidesPerView: 2,
            centeredSlides: false,
          },
        },
      })
    }
  } else {
    if (swiperProduct) {
      swiperProduct.destroy(true, true)
      swiperProduct = null
    }
  }
}

new Swiper(".swiper_team", {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  speed: 2500,
  centeredSlides: true,
  autoplay: {
    delay: 2000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  breakpoints: {
    320: {
      slidesPerView: 1.1,
      spaceBetween: 20,
    },
    460: {
      slidesPerView: 1.3,
      spaceBetween: 20,
    },
    600: {
      slidesPerView: 1.6,
      spaceBetween: 20,
    },
    740: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    880: {
      slidesPerView: 2.3,
      spaceBetween: 20,
    },
    1020: {
      slidesPerView: 2.6,
      spaceBetween: 20,
    },
    1160: {
      slidesPerView: 2.9,
      spaceBetween: 20,
    },
    1300: {
      slidesPerView: 3.4,
      spaceBetween: 20,
    },
    1440: {
      slidesPerView: 3.8,
      spaceBetween: 20,
    },
    1700: {
      slidesPerView: 4.3,
      spaceBetween: 20,
    },
    2000: {
      slidesPerView: 4.6,
      spaceBetween: 20,
    },
    2300: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
    2600: {
      slidesPerView: 7,
      spaceBetween: 20,
    },
    2900: {
      slidesPerView: 8,
      spaceBetween: 20,
    },
    3200: {
      slidesPerView: 9,
      spaceBetween: 20,
    },
  },
})

new Swiper(".image-swiper", {
  modules: [Pagination],
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  loop: true,
  speed: 1000,
  centeredSlides: false,
  breakpoints: {
    320: {
      slidesPerView: 1.06,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2.4,
    },
    1024: {
      slidesPerView: 2,
      centeredSlides: true,
      parallax: true,
    }
  },
})

new Swiper(".autoinformer_swiper", {
  modules: [Pagination, Navigation],
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  speed: 1000,
  centeredSlides: true,
  slidesPerView: 1,
})

window.addEventListener("resize", initSwiperProduct)

document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".reviews_slide-text")

  slides.forEach((slide) => {
    const textElement = slide.querySelector(".slide_text")
    const button = slide.querySelector(".toggle-button")

    if (textElement && button) {
      const isTextOverflowing = textElement.scrollHeight > textElement.clientHeight

      if (!isTextOverflowing) {
        button.style.display = "none"
      }
    }
  })
})

function toggleText(button) {
  const slideText = button.previousElementSibling

  const isExpanded = button.getAttribute("data-expanded") === "true"

  slideText.classList.toggle("expanded", !isExpanded)

  button.setAttribute("data-expanded", !isExpanded)

  button.textContent = isExpanded
    ? button.getAttribute("data-text-read-more")
    : button.getAttribute("data-text-read-less")
}

const buttons = document.querySelectorAll(".toggle-button")
buttons.forEach((button) => {
  button.addEventListener("click", function () {
    toggleText(button)
  })
})

window.addEventListener("load", () => {
  const jsTabs = document.querySelectorAll(".js-tabs")
  if (jsTabs) {
    jsTabs.forEach((container) => {
      new Tabs({
        container: container,
        itemTriggerSelector: ".js-tab-btn",
        itemContentSelector: ".js-tabs-item",
        activeClass: "active",
        duration: 300,
      })
    })
  }
})

window.addEventListener("load", () => {
  const accordionContainers = document.querySelectorAll(".js-accordion")
  if (accordionContainers) {
    accordionContainers.forEach((container) => {
      new Accordion({
        containerSelector: container,
        itemSelector: ".js-accordion-item",
        itemTriggerSelector: ".js-accordion-toggler",
        itemContentSelector: ".js-accordion-content",
        activeClass: "active",
        duration: 500,
        type: container.getAttribute("data-type") || "multiply",
        onOpenBefore: (accordionItem) => {
          accordionItem.$item.classList.add("active")
        },
      })
    })
  }
})

window.addEventListener("load", () => {
  const accordionContainers = document.querySelectorAll(".contact-center-accordion")
  if (accordionContainers) {
    accordionContainers.forEach((container) => {
      new Accordion({
        containerSelector: container,
        itemSelector: ".js-accordion-item",
        itemTriggerSelector: ".js-accordion-toggler",
        itemContentSelector: ".js-accordion-content",
        activeClass: "active",
        duration: 500,
        type: container.getAttribute("data-type") || "single",
        onOpenBefore: (accordionItem) => {
          accordionItem.$item.classList.add("active")
        },
      })
    })
  }
})

// gsap.registerPlugin(ScrollTrigger)
//
// if (window.innerWidth > 1200) {
//   const helpCards = document.querySelector(".help_cards")
//   const article = document.querySelector(".article")
//
//   if (helpCards && article) {
//     let tl = gsap.timeline({
//       scrollTrigger: {
//         trigger: helpCards,
//         pin: true,
//         start: "top 20px",
//         endTrigger: article,
//         end: "bottom bottom",
//         scrub: 1,
//       },
//     })
//   }
// }

document.addEventListener("DOMContentLoaded", function () {
  const tabsWrapper = document.querySelector(".voice_tabs")
  if (tabsWrapper) {
    const tabsBtns = tabsWrapper.querySelectorAll(".tabs__btn")
    const tabsHeadRow = tabsWrapper.querySelector(".tabs__head-row")

    if (!tabsBtns.length || !tabsHeadRow) return

    tabsBtns.forEach((btn, index) => {
      btn.addEventListener("click", function () {
        const activeBtn = document.querySelector(".tabs__btn.active")
        if (activeBtn) activeBtn.classList.remove("active")

        this.classList.add("active")

        const colors = ["var(--blue)", "var(--yellow)", "var(--green)", "var(--black2F)"]
        if (colors[index]) {
          tabsHeadRow.style.setProperty("--after-color", colors[index])
        }
      })
    })
  }
})

document.addEventListener("DOMContentLoaded", initHeroAnimationObserver)
document.addEventListener("DOMContentLoaded", initHeroTypeObserver)

function initHeroAnimationObserver() {
  const animatedItemsWrapper = document.querySelector(".animation-wrap")

  if (!animatedItemsWrapper) {
    return
  }

  const handleTyping = (wrapper) => {
    const typewriterElements = wrapper.querySelectorAll(".js-hero-type")
    queueTypewriter(typewriterElements)
  }

  if (typeof IntersectionObserver === "undefined") {
    animatedItemsWrapper.classList.add("is-visible")
    handleTyping(animatedItemsWrapper)
    return
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible")
          handleTyping(entry.target)
          obs.unobserve(entry.target)
        }
      })
    },
    {
      threshold: 0.3,
      rootMargin: "0px 0px -10% 0px",
    },
  )

  observer.observe(animatedItemsWrapper)
}

function initHeroTypeObserver() {
  const wrapper = document.querySelector(".animation-wrap")
  const typeElements = document.querySelectorAll(".js-hero-type")
  if (!typeElements.length) return

  if (!wrapper || typeof IntersectionObserver === "undefined") {
    wrapper && wrapper.classList.add("is-visible")
    queueTypewriter(typeElements)
    return
  }

  setTimeout(() => {
    const anyStarted = Array.from(typeElements).some(
      (element) => element.dataset.typingInitialized === "true",
    )
    if (!anyStarted) {
      wrapper.classList.add("is-visible")
      queueTypewriter(typeElements)
    }
  }, 2000)
}

function queueTypewriter(elements) {
  const ordered = Array.from(elements).filter(Boolean)
  if (!ordered.length) return

  const startNext = (index) => {
    if (index >= ordered.length) return
    startTypewriter(ordered[index], () => startNext(index + 1))
  }

  startNext(0)
}

function startTypewriter(element, onComplete) {
  if (!element) {
    if (typeof onComplete === "function") onComplete()
    return
  }

  if (element.dataset.typingInitialized === "true") {
    if (typeof onComplete === "function") onComplete()
    return
  }

  const originalText = element.textContent.trim()
  element.dataset.typingInitialized = "true"
  element.dataset.fullText = originalText
  element.textContent = ""

  const speed = Number(element.dataset.typeSpeed) || 40
  const delay = Number(element.dataset.typeDelay) || 0

  element.classList.add("hero-type--active")

  setTimeout(() => {
    const fullText = element.dataset.fullText || ""
    if (!fullText.length) {
      element.classList.remove("hero-type--active")
      element.classList.add("hero-type--done")
      if (typeof onComplete === "function") onComplete()
      return
    }
    let index = 0

    const interval = setInterval(() => {
      element.textContent += fullText.charAt(index)
      index += 1

      if (index >= fullText.length) {
        clearInterval(interval)
        element.classList.remove("hero-type--active")
        element.classList.add("hero-type--done")
        if (typeof onComplete === "function") onComplete()
      }
    }, speed)
  }, delay)
}

document.addEventListener("DOMContentLoaded", function () {
  const tabsWrapper = document.querySelector(".cloud-ua_tabs")

  if (tabsWrapper) {
    const tabsBtns = tabsWrapper.querySelectorAll(".tabs__btn")
    const tabsHeadRow = tabsWrapper.querySelector(".tabs__head-row")

    if (!tabsBtns.length || !tabsHeadRow) return

    tabsBtns.forEach((btn, index) => {
      btn.addEventListener("click", function () {
        const activeBtn = document.querySelector(".tabs__btn.active")
        if (activeBtn) activeBtn.classList.remove("active")

        this.classList.add("active")

        const colors = ["var(--green)", "var(--yellow)"]
        if (colors[index]) {
          tabsHeadRow.style.setProperty("--after-color", colors[index])
        }
      })
    })
  }
})

if (window.innerWidth <= 576) {
  document.addEventListener("DOMContentLoaded", function () {
    const footer = document.querySelector("footer")
    const footerTitles = footer.querySelectorAll(".footer_title")
    const footerLists = footer.querySelectorAll(".footer_list")

    footerTitles.forEach((title, index) => {
      title.addEventListener("click", () => {
        title.classList.toggle("active")

        const correspondingList = footerLists[index]
        correspondingList.classList.toggle("open")
      })
    })
  })
}

document.addEventListener("DOMContentLoaded", function () {
  const trialBody = document.querySelector(".trial_without-additional-content")
  if (!trialBody) {
    return
  }
  const dialBtn = trialBody.querySelector(".btn")
  const dialModal = document.querySelector(".trial_modal")
  const shadow = document.querySelector(".drop-shadow")

  dialBtn.addEventListener("click", () => {
    dialModal.classList.add("open")
    shadow.classList.add("show")
    document.body.classList.add("lock")
  })
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      dialModal.classList.remove("open")
      shadow.classList.remove("show")
      document.body.classList.remove("lock")
      let modal_buttons = document.querySelectorAll(".close-form-btn")
      modal_buttons.forEach((btn) => {
        btn.dispatchEvent(new Event("click"))
      })
    }
  })
})
function changePricingText() {
  const spansWrap = document.querySelector(".bottom_row")
  if (!spansWrap) return
  const spans = spansWrap.querySelectorAll("span")
  spans.forEach((span) => {
    const mobileText = span.getAttribute("data-mobile-text")
    const pcText = span.getAttribute("data-pc-text")

    if (window.innerWidth <= 992) {
      span.textContent = mobileText
    } else {
      span.textContent = pcText
    }
  })
}

window.addEventListener("resize", changePricingText)

document.addEventListener("DOMContentLoaded", changePricingText)

document.addEventListener("DOMContentLoaded", function () {
  let last_check = [...document.querySelectorAll(".icon-check_wrap")].pop()
  last_check && last_check.closest(".col_item").classList.add("last-child")
})

document.addEventListener("DOMContentLoaded", function () {
  const modalCookies = document.getElementById("modal_cookies")
  const modalCloseBtn = document.querySelector(".modal__close-btn")

  if (modalCookies && modalCloseBtn) {
    if (!localStorage.getItem("cookiesAccepted")) {
      modalCookies.classList.add("show")
    }

    modalCloseBtn.addEventListener("click", function () {
      localStorage.setItem("cookiesAccepted", "true")
      modalCookies.classList.remove("show")
    })
  }
})

const clientsMarquee = document.querySelector(".clients-marquee")
if (clientsMarquee) Marquee(clientsMarquee, 2, "left")

document.addEventListener("DOMContentLoaded", function () {
  const card_has_link = document.querySelectorAll(".card_has_link")
  card_has_link &&
    card_has_link.forEach((card) => {
      card.addEventListener("mouseenter", (e) => {
        let current_height = e.target.clientHeight
        e.target.style.height = current_height - 10 + "px"
        setTimeout(function () {
          e.target.style.height = current_height + 50 + "px"
        }, 200)
      })
      card.addEventListener("mouseleave", (e) => {
        setTimeout(function () {
          e.target.style.removeProperty("height")
        }, 300)
      })
    })
})

document.addEventListener("DOMContentLoaded", function () {
  const cardParent = document.querySelector(".connect")
  if (!cardParent) return
  const cardHovered = cardParent.querySelectorAll(".card_img")
  const cardTarget = cardParent.querySelectorAll(".full__image")

  cardHovered.forEach((card, index) => {
    card.addEventListener("mouseenter", () => {
      cardTarget[index].classList.add("show")
    })

    card.addEventListener("mouseleave", () => {
      cardTarget[index].classList.remove("show")
    })
  })
})

document.addEventListener("DOMContentLoaded", function () {
  const copyLinks = document.querySelectorAll(".copy-article-link")

  copyLinks.forEach((button) => {
    button.addEventListener("click", async () => {
      await window.navigator.clipboard.writeText(window.location.href).then(() => {
        button.classList.add("copied")
        button.querySelector("use").setAttribute("href", "/v2/icon/icons/icons.svg#check")
      })
    })
  })
})

function setupManualTabProgress(tabsContainerId = "stepsTab") {
  const tabsContainer = document.getElementById(tabsContainerId)
  if (!tabsContainer) return

  const tabButtons = tabsContainer.querySelectorAll(".tabs__btn")
  const line1 = tabsContainer.querySelector("#line1")
  const line2 = tabsContainer.querySelector("#line2")
  const lines = [line1, line2]

  let autoplayTimer = null
  const autoplayDelay = 3000

  function resetLines() {
    lines.forEach((line) => {
      if (line) line.classList.remove("fill")
    })
  }

  function startProgress(lineEl) {
    if (!lineEl) return
    lineEl.classList.remove("fill")
    void lineEl.offsetWidth
    lineEl.classList.add("fill")
  }

  function goToStep(index) {
    if (index < tabButtons.length) {
      tabButtons[index].click()
    }
  }

  function startAutoplay(currentIndex = 0) {
    if (autoplayTimer) clearTimeout(autoplayTimer)

    const nextIndex = currentIndex % tabButtons.length
    goToStep(nextIndex)

    autoplayTimer = setTimeout(() => {
      startAutoplay(nextIndex + 1)
    }, autoplayDelay)
  }

  tabButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      resetLines()
      clearTimeout(autoplayTimer)

      if (index === 1) {
        startProgress(line1)
      } else if (index === 2) {
        startProgress(line2)
      }
    })
  })

  startAutoplay(0)
}

function articleVoted() {
  const starButtons = document.querySelectorAll(".stars button")
  // const currentRatingEl = document.querySelector(".curent_rating")
  // const votesCountEl = document.querySelector(".votes_count")
  let localStorageKey = "userArticleRating_"

  if (document.querySelector(".article")) {
    localStorageKey += document.querySelector(".article").dataset.id
  }
  let currentRating = 0
  let totalVotes = 0
  let cumulativeScore = 0

  const savedRating = localStorage.getItem(localStorageKey)
  if (savedRating) {
    currentRating = parseInt(savedRating, 10)
    totalVotes = 1
    cumulativeScore = currentRating
    // currentRatingEl.textContent = currentRating.toFixed(1)
    // votesCountEl.textContent = totalVotes
    highlightStars(currentRating)
  }

  function sendRatingToServer(rating) {
    let url = "/article-vote/"
    if (document.querySelector(".article")) {
      url += document.querySelector(".article").dataset.id
    }

    const formData = new FormData()
    formData.append("rate", rating)

    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Server error: ${response.status}`)
        }
        return response.text()
      })
      .then((data) => {
        console.log("Оцінку успішно надіслано:", data)
        let info = JSON.parse(data)
        document.querySelector(".curent_rating").textContent = info.rating
        document.querySelector(".total_votes").textContent = info.count_votes
      })
      .catch((error) => {
        console.error("Помилка при надсиланні оцінки:", error)
      })
  }

  starButtons.forEach((button, index) => {
    const rating = index + 1

    button.addEventListener("mouseenter", () => {
      if (localStorage.getItem(localStorageKey)) return
      highlightStars(rating)
    })

    button.addEventListener("mouseleave", () => {
      highlightStars(currentRating)
    })

    button.addEventListener("click", function (e) {
      if (localStorage.getItem(localStorageKey)) return

      currentRating = rating
      cumulativeScore += rating
      totalVotes += 1

      localStorage.setItem(localStorageKey, rating)

      sendRatingToServer(rating)

      // currentRatingEl.textContent = (cumulativeScore / totalVotes).toFixed(1)
      // votesCountEl.textContent = totalVotes
      button.closest(".stars").classList.add("voted")
      highlightStars(currentRating)
    })
  })

  function highlightStars(rating) {
    starButtons.forEach((btn, i) => {
      btn.classList.toggle("active", i < rating)
    })
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const sticky = document.querySelector("#call")
  const footer = document.querySelector(".footer")
  const offsetFromFooter = 40

  function handleScroll() {
    const stickyHeight = sticky.offsetHeight
    const footerTop = footer.getBoundingClientRect().top + window.scrollY
    const scrollPosition = window.scrollY + window.innerHeight

    const stopPoint = footerTop - stickyHeight - offsetFromFooter

    if (scrollPosition > stopPoint + stickyHeight) {
      sticky.classList.add("sticky-stop")
      sticky.style.top = stopPoint + "px"
    } else {
      sticky.classList.remove("sticky-stop")
      sticky.style.top = ""
    }
  }

  window.addEventListener("resize", handleScroll)
  window.addEventListener("scroll", handleScroll)
  handleScroll()
})

function openCallModal() {
  const callBtn = document.querySelector(".call_mob-btn")
  const openFormBtn = document.querySelector(".call_btn")
  const closeFormBtn = document.querySelector("#closeCallbackForm")
  const callBody = document.querySelector(".call_body")
  const backdrop = document.querySelector(".call_backdrop")
  const callbackModal = document.querySelector("#callback-modal")
  const container = document.querySelector(".callback-container")

  callBtn && callBtn.addEventListener("click", () => {
    callBody.classList.toggle("show")
    callBtn.classList.toggle("active")
    backdrop.classList.toggle("show")
    document.body.classList.toggle("lock")
  })

  openFormBtn && openFormBtn.addEventListener("click", () => {
    callbackModal.classList.add("openContactForm")
    container.classList.add("showContactFormContainer")
    document.body.classList.add("lock")
  })

  closeFormBtn && closeFormBtn.addEventListener("click", () => {
    callbackModal.classList.remove("openContactForm")
    container.classList.remove("showContactFormContainer")
    document.body.classList.remove("lock")
  })
}

function zoomArticleImage() {
  const images1 = document.querySelectorAll(".article_content img")
  const images2 = document.querySelectorAll(".image-slider__img")

  const images = [...images1, ...images2]

  images.forEach((thumb) => {
    !thumb.closest("a") &&
      thumb.addEventListener("click", () => {
        const modal = document.createElement("div")
        modal.className = "img-modal zoom"

        const closeBtn = document.createElement("button")
        closeBtn.className = "close_btn"

        const backdrop = document.createElement("div")
        backdrop.className = "backdrop"

        const imageWrapper = document.createElement("div")
        imageWrapper.className = "image-wrapper"

        const fullImage = document.createElement("img")
        fullImage.src = thumb.src
        fullImage.alt = thumb.alt || "image"

        imageWrapper.appendChild(fullImage)
        imageWrapper.appendChild(closeBtn)
        modal.appendChild(backdrop)
        modal.appendChild(imageWrapper)
        document.body.appendChild(modal)
        document.body.classList.add("lock")

        function closeModal() {
          if (document.body.contains(modal)) {
            document.body.removeChild(modal)
            document.body.classList.remove("lock")
          }
          document.removeEventListener("keydown", escListener)
        }

        closeBtn.addEventListener("click", closeModal)
        backdrop.addEventListener("click", closeModal)

        function escListener(e) {
          if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
            closeModal()
          }
        }
        document.addEventListener("keydown", escListener)
      })
  })
}

function openIntegrationFilters() {
  const filtersModal = document.querySelectorAll(".popular-integration__filter-wrapper")
  const filtersModalClose = document.querySelectorAll(".popular-integration__filter-head-close")
  const filtersModalOpen = document.querySelectorAll(".popular-integration__filter-head-open")

  function openModal() {
    filtersModal.forEach((modal) => {
      modal.classList.add("open")
    })
    document.body.classList.add("lock")
    document.addEventListener("keydown", escListener)
  }

  function closeModal() {
    filtersModal.forEach((modal) => {
      modal.classList.remove("open")
    })
    document.body.classList.remove("lock")
    document.removeEventListener("keydown", escListener)
  }

  function escListener(e) {
    if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
      closeModal()
    }
  }

  filtersModalOpen.forEach((openBtn) => {
    openBtn.addEventListener("click", openModal)
  })

  filtersModalClose.forEach((closeBtn) => {
    closeBtn.addEventListener("click", closeModal)
  })
}

function setupFilterReset() {
  const resetButton = document.querySelector(".popular-integration__filter-button-reset")
  const applyButton = document.querySelector(".popular-integration__filter-button-apply")
  const integartion_search = document.querySelector("[name='integration_search']")
  const checkboxes = document.querySelectorAll(
    ".popular-integration__filter-item input[type='radio']",
  )

  resetButton &&
    resetButton.addEventListener("click", () => {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false
      })
      integartion_search.value = ""

      resetButton.disabled = true
      resetButton.classList.add("disabled")

      applyButton.disabled = true
      applyButton.classList.add("disabled")
    })
  integartion_search &&
    integartion_search.addEventListener("input", () => {
      disableTrigger()
    })

  checkboxes &&
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        disableTrigger()
      })
    })
  const disableTrigger = () => {
    const anyChecked = Array.from(checkboxes).some((cb) => cb.checked)
    resetButton.disabled = !anyChecked
    applyButton.disabled = !anyChecked

    if (anyChecked || integartion_search.value !== "") {
      resetButton.classList.remove("disabled")
      applyButton.removeAttribute("disabled")
    } else {
      resetButton.classList.add("disabled")
      applyButton.addAttribute("disabled")
    }
  }
}
showMoreArticles()
function showMoreArticles() {
  const articlesBtn = document.querySelectorAll(".show-more-btn")

  articlesBtn.forEach((button) => {
    const loadingText = button.dataset.loadingText || "Loading..."
    const defaultText = button.dataset.defaultText || "Show more"
    const noArticlesText = button.dataset.noArticlesText || "No more articles"

    button.addEventListener("click", () => {
      const url = button.dataset.url || "/blog"

      button.disabled = true
      button.textContent = loadingText

      const formData = new FormData()
      formData.append("page", button.dataset.page || 2)

      fetch(url, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Server error: ${response.status}`)
          }
          return response.text()
        })
        .then((data) => {
          button.insertAdjacentHTML("beforebegin", data)
          if (data) {
            button.disabled = false
            button.textContent = defaultText
            button.dataset.page = parseInt(button.dataset.page || 2) + 1
          } else {
            button.textContent = noArticlesText
          }
        })
        .catch((error) => {
          console.error("Помилка при завантаженні статей:", error)
        })
    })
  })
}

document.addEventListener("DOMContentLoaded", function () {
  const priceTabs = document.getElementById("dialTabs")

  if (window.location.hash && priceTabs) {
    const clickEvent = new MouseEvent("click", {
      bubbles: false,
      cancelable: true,
    })

    const tab = document.querySelector(`[data-tab-id="${window.location.hash.replace(/^#+/, "")}"]`)
    tab && tab.dispatchEvent(clickEvent)
  }
})

document.addEventListener("DOMContentLoaded", () => {
  new wrapTable()
})

document.addEventListener("DOMContentLoaded", () => {
  const allTabs = document.querySelectorAll(".industry-tabs")

  if (allTabs.length) {
    allTabs.forEach((container) => {
      const dataIndex = container.getAttribute("data-start-index")
      const initialIndex = dataIndex ? parseInt(dataIndex) : 0

      new Tabs({
        container: container,
        activeIndex: initialIndex,
        duration: 300,
      })
    })
  }
})

new Swiper(".numbered_list_swiper", {
  modules: [Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: 30,
  speed: 800,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".numbered-list-button-next",
    prevEl: ".numbered-list-button-prev",
  },
})

document.addEventListener("DOMContentLoaded", () => {
  initUniversalPlayer()
})
